import { Icon, IconProps } from '@chakra-ui/react'

export default function IntegrationIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M10.6667 14.5013H12C13.1046 14.5013 14 13.6059 14 12.5013V11.168"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 2.5H12C13.1046 2.5 14 3.39543 14 4.5V5.83333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 11.168V12.5013C2 13.6059 2.89543 14.5013 4 14.5013H5.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 5.83333V4.5C2 3.39543 2.89543 2.5 4 2.5H5.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.23649 8.59766L5.19526 9.63889C5.07024 9.76391 5 9.93348 5 10.1103V10.8341C5 11.2023 5.29848 11.5008 5.66667 11.5008H6.39053C6.56734 11.5008 6.7369 11.4306 6.86193 11.3056L7.9032 10.2643"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.23652 8.59684C6.17131 8.38158 6.13659 8.15824 6.13336 7.93333C6.13336 6.58944 7.2228 5.5 8.5667 5.5C9.91059 5.5 11 6.58944 11 7.93333C11 9.27723 9.91059 10.3667 8.5667 10.3667C8.34181 10.3634 8.11849 10.3287 7.90324 10.2635"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.57299 7.9349L8.56966 7.93823L8.56633 7.9349L8.56966 7.93156L8.57299 7.9349"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
